import { Injectable, TemplateRef, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MobileExplainTooltipSheetService {
  private router = inject(Router);

  public readonly content = signal<TemplateRef<void> | string | null>(null);
  public readonly learnMoreLink = signal<string | null>(null);

  public constructor() {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => !!this.content() && this.close());
  }

  public isTemplateRef(value: TemplateRef<void> | string): value is TemplateRef<void> {
    return value instanceof TemplateRef;
  }

  public open(content: TemplateRef<void> | string, learnMoreLink: string | null = null): void {
    this.learnMoreLink.set(learnMoreLink);
    this.content.set(content);
  }

  public close(): void {
    this.content.set(null);
    this.learnMoreLink.set(null);
  }
}
